import { connect } from "react-redux";

import ResendConfirm from "./ForgotPassword";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ResendConfirm);
